import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";
import {
  Bug,
  Cloud,
  Code2,
  HardDrive,
  Headphones,
  Network,
  ShieldCheck,
} from "lucide-react";

const ICONS = [Network, Code2, ShieldCheck, Cloud, HardDrive, Headphones, Bug];
const SPANS = [
  "md:col-span-8", "md:col-span-4", "md:col-span-4", "md:col-span-8",
  "md:col-span-6", "md:col-span-6", "md:col-span-12",
];

export default function Services() {
  const { t } = useLang();
  const items = t("services");
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#0B1120] px-6 md:px-12 lg:px-24 py-20 lg:py-32"
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
        <Reveal>
          <p className="text-xs tracking-[0.25em] uppercase text-[#ED1C24] mb-4">
            {t("services_label")}
          </p>
          <h2 className="font-display font-semibold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight">
            {t("services_title1")}
            <br />
            {t("services_title2").replace(".", "")}<span className="text-[#ED1C24]">.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-slate-400 max-w-sm text-sm lg:text-base">
            {t("services_sub")}
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-12 gap-5">
        {items.map(([title, desc], i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={title} delay={(i % 3) * 0.08} className={SPANS[i]}>
              <div
                data-testid={`service-card-${i}`}
                className="spotlight-card group h-full border border-white/10 bg-white/[0.03] p-8 hover:border-[#ED1C24]/60 hover:-translate-y-1.5 transition-[border-color,transform] duration-500"
                onMouseMove={(e) => {
                  const r = e.currentTarget.getBoundingClientRect();
                  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
                  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
                }}
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="w-11 h-11 bg-[#ED1C24]/15 border border-[#ED1C24]/30 flex items-center justify-center text-[#ED1C24] group-hover:bg-[#ED1C24] group-hover:text-white transition-colors duration-500">
                    <Icon size={20} />
                  </span>
                  <span className="font-display text-sm text-slate-600 group-hover:text-[#FFC61A] transition-colors duration-500">
                    /{String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-display font-semibold text-white text-xl lg:text-2xl mb-3">
                  {title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed">{desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
